//课件url前置
export const COURSE_URL = "/h5";

export const ROUND_NAME = {
    1: "carriage",
    2: "archery",
    3: "castle",
    4: "castle",
};

export const WEEK = {
    0: "周日",
    1: "周一",
    2: "周二",
    3: "周三",
    4: "周四",
    5: "周五",
    6: "周六",
};



// WEBPACK FOOTER //
// ./src/constants.js